import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { resetPassword } from "../../../services/loginService";
import { useStoreon } from "storeon/react";
import { LOGOUT } from "../../../store/auth";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import "./resetPasswordBox.scss";
import InputGroup from "../../components/inputGroup/InputGroup";
import { success } from "../../components/toast/toast";

const ResetPasswordForm = (props) => {
  const { values, handleChange, handleBlur, errors, touched } = props;
  const { dispatch } = useStoreon("auth");

  const history = useHistory();
  const location = useLocation();

  const goToLogin = () => {
    history.push("/login");
  };

  const handleReset = (e) => {
    let search = location.search;
    let params = new URLSearchParams(search);
    let code = params.get("code");
    const data = {
      password: values.newPassword,
      code: code,
    };
    e.preventDefault();
    props.setTouched(
      Object.keys(values).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {}),
      true
    );
    console.log("before", Object.keys(touched));
    if (Object.keys(touched).length > 0 && !Object.keys(errors).length > 0) {
      console.log("after");
      resetPassword(data).then((res) => {
        if (res.success === true || res.statusCode === 200) {
          success("Your password has been set successfully", {
            onClose: () => {
              dispatch(LOGOUT);
              history.push("/login");
            },
          });
        }
      });
    }
  };

  return (
    <form className="loginForm" onSubmit={handleReset}>
      <InputGroup
        id="resetBox_newPassword"
        name="newPassword"
        label={"New Password"}
        inputValue={values.newPassword}
        onChange={handleChange}
        onBlur={handleBlur}
        className="formGroupLogin"
        errors={errors}
        touched={touched}
      />
      <InputGroup
        id="resetBox_newPasswordConfirm"
        name="newPasswordConfirm"
        label={"New Password Confirm"}
        inputValue={values.newPasswordConfirm}
        onChange={handleChange}
        onBlur={handleBlur}
        className="formGroupLogin"
        errors={errors}
        touched={touched}
      />
      <div className="formGroupLogin signIn">
        <label
          className="rememberMeCbText"
          style={{ cursor: "pointer" }}
          onClick={goToLogin}
        >
          Login
        </label>

        <button
          type="submit"
          className={`${themeStyles.btnPrimary} btnReset`}
          disabled={false}
        >
          Reset
        </button>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
